/**
 * Role constants and the role -> landing-page map.
 *
 * Kept out of the provider so any module can import these without pulling in
 * React context. The reference project duplicated its role/dashboard mapping in
 * four separate places, which is how they drift apart.
 */

export const ROLES = {
  // The platform operator, above any single customer. Everything else runs
  // inside one organisation; this role is the only one that sees across them.
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  VENDOR: 'VENDOR',
  CUSTOMER: 'CUSTOMER',
};

/** Roles that may open the admin console. An operator is not less privileged
 *  than a tenant admin, so they get both consoles rather than a separate one. */
export const ADMIN_ROLES = [ROLES.SUPER_ADMIN, ROLES.ADMIN];

export const HOME_BY_ROLE = {
  // An operator lands on the platform overview: every shop at once, not any
  // one customer's vendor queue.
  [ROLES.SUPER_ADMIN]: '/admin/overview',
  [ROLES.ADMIN]: '/admin',
  [ROLES.VENDOR]: '/vendor',
  [ROLES.CUSTOMER]: '/account',
};

export function homePathFor(role) {
  return HOME_BY_ROLE[role] ?? '/';
}
